// src/processors/template/template-file-handler.ts
import { XConVitePluginOptions } from '../../types';
import { fsUtils } from '../../utils/fs-utils';
import {Logger} from "../../utils/logger";

/**
 * Handles HTML template file loading and path resolution
 */
export class TemplateFileHandler {
    constructor(
        private options: Required<XConVitePluginOptions>,
        private logger: Logger
    ) {}

    /**
     * Load HTML template file content with proper path resolution
     */
    loadTemplateFile(
        templatePath: string,
        id: string,
        addWatchFile: (file: string) => void
    ): string | null {
        const path = require('path');
        const tsFileDir = path.dirname(id);
        const fullTemplatePath = path.resolve(tsFileDir, templatePath);

        this.logger.debug(`  📂 Resolving template:`);
        this.logger.debug(`     Source file: ${id}`);
        this.logger.debug(`     Template ref: ${templatePath}`);
        this.logger.debug(`     Resolved to: ${fullTemplatePath}`);

        if (this.options.watchFiles && fsUtils.isNodeEnvironment()) {
            addWatchFile(fullTemplatePath);
        }

        if (!fsUtils.existsSync(fullTemplatePath)) {
            this.logger.warn(`❌ HTML template not found: ${fullTemplatePath}`);
            this.logger.warn(`   Referenced as: ${templatePath}`);
            this.logger.warn(`   From file: ${id}`);
            return null;
        }

        try {
            const content = fsUtils.readFileSync(fullTemplatePath, 'utf8');
            const sizeKB = (content.length / 1024).toFixed(2);
            this.logger.debug(`  ✅ Template loaded: ${path.basename(fullTemplatePath)} (${sizeKB}KB)`);
            return content;
        } catch (error) {
            this.logger.error(`❌ Failed to read template: ${fullTemplatePath}`, error);
            return null;
        }
    }
}